// 数字四舍五入保留小数点后两位
export const takeInteger = (num: number | string) => {
  if (num) {
    if (typeof num === 'string') {
      return Number(Number(num).toFixed(2));
    }
    if (typeof num === 'number') {
      return Number(num.toFixed(2));
    }
  }
  return 0;
};

// 字符串保留小数点后两位
export const stringTakeInteger = (num: number | string) => {
  if (num) {
    if (typeof num === 'number') {
      if (String(num).indexOf('.') !== -1) {
        const startNum = String(num).split('.')[0];
        const endNum = String(num).split('.')[1].substring(0, 2);
        return Number(`${startNum}.${endNum}`) || 0;
      }
      return Number(num) || 0;
    }
    if (typeof num === 'string') {
      if (num.indexOf('.') !== -1) {
        const startNum = String(num).split('.')[0];
        const endNum = String(num).split('.')[1].substring(0, 2);
        return Number(`${startNum}.${endNum}`) || 0;
      }
      return Number(num) || 0;
    }
  } else {
    return '';
  }
};
